import { Stack, Text } from '@fluentui/react';
import clsx from 'clsx';
import { useCommonStyles } from 'common/styles';
import React, { PropsWithChildren } from 'react';
import { useStyles } from './index.styles';

interface FilterBadgeProps {
  visible?: boolean;
  filtersCount: number;
}

export const FilterBadge: React.FC<FilterBadgeProps & PropsWithChildren> = ({
  visible,
  filtersCount,
  children,
}) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();
  if (!visible) {
    if (!children) return null;
    return <>{children}</>;
  }

  return (
    <span className={styles.root}>
      {children}
      <Stack className={commonStyles.badge}>
        <Text className={clsx(styles.textStyles, commonStyles.bold)}>
          {filtersCount}
        </Text>
      </Stack>
    </span>
  );
};
